// extracted by mini-css-extract-plugin
export default {"skeletonMenuBar":"topMenu-module__skeletonMenuBar__rXMdc","hotelMenuBar":"topMenu-module__hotelMenuBar__4l12E"};